import styled from "@emotion/styled";

export const SmallContainer = styled("div")(({ theme }) => ({
    width : "100%" ,
    height : "100%" ,
    marginBottom : "20px" , 
    padding : "0 10px" ,
}));